import jquery from 'jquery';
window.jQuery = jquery

;(function(window, document, $) {
	var $win = $(window);
	var $doc = $(document);
	var activeClass = 'active';

	/**
	 * Adding/removing class active on label
	 * if the field is empty, and if the field its focused or not
	 */

	function focusField() {
		$('.middleColumn input, textarea').focus(function() {
			var $label = $(this).closest('.field').find('label');
			$label.addClass(activeClass);

			if (!$(this).val() && !$label.hasClass(activeClass)) {
				$(this).closest('.field').find('label').removeClass(activeClass);
			} else {
				$(this).closest('.field').find('label').addClass(activeClass);
			}
		});

		$('.middleColumn input, textarea').focusout(function() {
			var $label = $(this).closest('.field').find('label');

			if (!$(this).val() && $label.hasClass(activeClass)) {
				$(this).closest('.field').find('label').removeClass(activeClass);
			}
		});
	}

	focusField();

	/**
	 * Scroll to section
	 */

	 $('.js-scroll-to').on('click', function() {
	 	event.preventDefault();

	 	var link = $(this).attr('href');

	 	$('html, body').animate({
	 		scrollTop: $(link).offset().top
	 	}, 800);

	 });

	 /**
	  * Nav trigger function
	  */

	 $('.nav-trigger').on('click', function() {
	 	event.preventDefault();

	 	$(this).toggleClass(activeClass);
	 	$('body').toggleClass(activeClass);
	 	$('.nav').slideToggle();
	 });

	 $win.on('resize', function() {
	 	if ($win.outerWidth() > 767) {
	 		if ($('body').hasClass(activeClass) && $('.nav-trigger').hasClass(activeClass)) {
		 		console.log(1);
		 		$('body').removeClass(activeClass);
		 		$('.nav-trigger').removeClass(activeClass);
		 		$('.nav').slideUp();
	 		}
		 }
	 });

	//Handle the show/hide logic
	$('.js-accordion').on('click', '.accordion__head', function (event) {
		$(this).next().stop().slideToggle()
			.parent().toggleClass('accordion__section--current')
			.siblings().removeClass('accordion__section--current')
				.find('.accordion__body').slideUp();

	});

	$win.on('scroll', function() {
		if ($doc.scrollTop()) {
			$('header').addClass('fixed');
		} else {
			$('header').removeClass('fixed');
		}
	}).trigger('scroll');

	// Nav functionality
	$('nav ul li.has-dropdown').hover(
		function(){
			if($win.outerWidth() >= 768){
				$(this).addClass(activeClass)
			}
		},
		function(){
			if($win.outerWidth() >= 768){
				$(this).removeClass(activeClass)
			}
		}
	);

	$('nav ul li.has-dropdown').on('click', function (e) {
		if($win.outerWidth() < 768){
			e.preventDefault();
			var dropdown = $(this).find('.dropdown-menu');
			$(this).toggleClass(activeClass);
			dropdown.slideToggle();
		}
	});

	// Stop propagation to follow the link instead of sliding up the nav menu
	$('nav .dropdown-menu a').on('click', function (e) {
		if($win.outerWidth() < 768){
			e.stopPropagation();
		}
	});

})(window, document, window.jQuery);
